import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/park/coupon/coupon/list', Object.assign({}, options, { params }));

export const getCouponList = (params, options) =>
request.get('/api/v4ward/park/coupon/coupon/selectionList', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/park/coupon/coupon/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
request.post('/api/v4ward/park/coupon/coupon/deleteCarCoupon', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/park/coupon/coupon/save', params,options);

export const update = (params, options) =>
request.post('/api/v4ward/park/coupon/coupon/submit', params,options);

export const syncCoupon = (params, options) =>
  request.post('/api/v4ward/park/coupon/coupon/sync', qs.stringify(params),options);
